export const SIDEBAR_ICON_WIDTH = '44px'
export const SIDEBAR_EXPANDED_WIDTH = '16rem'
export const SIDEBAR_ICON_SLOT_CLASS =
    'relative z-10 flex h-full w-[44px] shrink-0 items-center justify-center'
export const SIDEBAR_RAIL_HIDE_CLASS =
    'group-data-[rail=collapsed]:pointer-events-none group-data-[rail=collapsed]:opacity-0'
export const SIDEBAR_LUCIDE_STROKE = 1.2
export const SIDEBAR_WORDMARK_CLASS = 'block w-[130px] [&>svg]:block'
export const SIDEBAR_WORDMARK_NUDGE_CLASS =
    'flex translate-x-[2px] translate-y-[4px] items-center'
export const SIDEBAR_SECTION_LABEL_CLASS =
    'h-auto min-h-0 w-full py-1 pl-4 text-[11px] font-normal uppercase tracking-wide text-sidebar-foreground/40'
export const SIDEBAR_NAV_PILL_CLASS =
    "before:pointer-events-none before:absolute before:inset-y-0.5 before:left-1.5 before:right-auto before:w-[calc(100cqw-theme(spacing.3))] before:rounded-md before:content-['']"

export function getSidebarVisualOpen({
    open,
    hovered,
    hoverLocked,
    hoverExpand,
}: {
    open: boolean
    hovered: boolean
    hoverLocked: boolean
    hoverExpand: boolean
}): boolean {
    if (!hoverExpand) {
        return open
    }

    return open || hovered || hoverLocked
}

export function isClientPointInsideRect(
    x: number,
    y: number,
    rect: Pick<DOMRect, 'left' | 'right' | 'top' | 'bottom'>,
): boolean {
    return x >= rect.left && x < rect.right && y >= rect.top && y < rect.bottom
}

export function isPointerInsideElement(
    event: {
        clientX: number
        clientY: number
        relatedTarget: EventTarget | null
    },
    element: EventTarget | null,
): boolean {
    if (!(element instanceof Element)) {
        return false
    }

    if (
        event.relatedTarget instanceof Node &&
        element.contains(event.relatedTarget)
    ) {
        return true
    }

    return isClientPointInsideRect(
        event.clientX,
        event.clientY,
        element.getBoundingClientRect(),
    )
}

export function getSidebarLayoutExpanded({
    open,
    hoverExpand,
    reserveLayout,
    visuallyOpen,
}: {
    open: boolean
    hoverExpand: boolean
    reserveLayout: boolean
    visuallyOpen: boolean
}): boolean {
    if (!hoverExpand) {
        return visuallyOpen
    }

    return open || (reserveLayout && visuallyOpen)
}
